var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"clear-button"},[_c('span',{staticClass:"clear-button__icon"},[_c('CloseIcon')],1),_c('span',{staticClass:"clear-button__text"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }